import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "flex h-screen flex-col space-y-10 bg-gray-50" }
const _hoisted_2 = { class: "flex min-h-full flex-col justify-center px-6 py-12 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center sm:mx-auto sm:w-full sm:max-w-sm" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    id: "logo-77",
    width: "300"
  })
], -1)
const _hoisted_4 = { class: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm" }
const _hoisted_5 = { class: "space-y-6" }
const _hoisted_6 = {
  key: 0,
  class: "p-4 rounded-md bg-gray-200"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"flex\"><div class=\"flex-1 md:flex md:justify-between\"><p class=\"text-sm text-primary\">Vi har sendt en SMS med en midlertidig adgangskode, der er gyldig i 10 minutter.</p><p class=\"mt-3 text-sm md:ml-6 md:mt-0\"><a href=\"#\" class=\"whitespace-nowrap underline font-medium text-blue-800 hover:text-blue-700\">Jeg har ikke modtaget den</a></p></div></div>", 1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Mobil nummer", -1)
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "SMS kode", -1)
const _hoisted_14 = {
  key: 0,
  class: "m-2 hidden text-sm text-error peer-[&:not(:focus):invalid]:block"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", _hoisted_5, [
          (_ctx.loginForm.passwordSendState === 200)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _hoisted_9,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                id: "phone",
                name: "phone",
                type: "tel",
                autocomplete: "mobile",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.userName) = $event)),
                disabled: _ctx.loginForm.passwordSendState === 200,
                required: "",
                class: "peer block w-full rounded-md border-0 p-2.5 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary disabled:bg-gray-200 sm:text-sm sm:leading-6",
                value: "12345678"
              }, null, 8, _hoisted_10), [
                [_vModelText, _ctx.loginForm.userName]
              ]),
              _createElementVNode("span", {
                class: "m-2 hidden text-sm text-error peer-[&:not(:focus):invalid]:block",
                disabled: _ctx.loginForm.passwordSendState === 500
              }, "Angiv et gyldigt mobil nummer.", 8, _hoisted_11)
            ])
          ]),
          (_ctx.loginForm.passwordSendState === 200)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "password",
                    name: "password",
                    type: "password",
                    autocomplete: "current-password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                    required: "",
                    class: "peer block w-full rounded-md border-0 p-2.5 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6"
                  }, null, 512), [
                    [_vModelText, _ctx.loginForm.password]
                  ]),
                  (_ctx.loginForm.loginState === 500)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Forkerte adgangsoplysninger."))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.loginForm.passwordSendState === 200)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("span", {
                  type: "submit",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
                  class: "span-button flex w-full justify-center rounded-md bg-primary px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"
                }, "Log ind")
              ]))
            : _createCommentVNode("", true),
          (_ctx.loginForm.passwordSendState !== 200)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("span", {
                  type: "submit",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.password && _ctx.password(...args))),
                  class: "span-button flex w-full justify-center rounded-md bg-primary px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"
                }, "Send SMS")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}